export enum LegacyProposalAPI {
  AllowanceProposal = 'allowanceproposal',
  BenefitProposal = 'benefitproposal',
  BillableHoursProposal = 'billablehoursproposal',
  BonusProposal = 'incentiveshortproposal',
  SalaryProposal = 'salaryproposal',
}
